// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mtpStatusReviewedModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#mtpStatusReviewedModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#mtpStatusReviewedModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#mtpStatusReviewedModal .btn-link:focus {
  text-decoration: none;
}
#mtpStatusReviewedModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#mtpStatusReviewedModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
}
@media (min-width: 2024px) {
#mtpStatusReviewedModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#mtpStatusReviewedModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#mtpStatusReviewedModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#mtpStatusReviewedModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#mtpStatusReviewedModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#mtpStatusReviewedModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
